export default __webpack_public_path__ + "static/media/brooklyn-nets.0f050f91.jpeg";